import { Button } from '@spritz-finance/ui'
import { useState } from 'react'
import { ADD_BANK_ACCOUNT_EVENT } from '../../../../analytics/events'
import { Row } from '../../../../components/Layout/Row'
import { useAnalytics } from '../../../../context/useAnalytics'
import { AddAccountDialog } from './AddAccountDialog'

export const AddAccount = () => {
    const { trackAnalyticsEvent } = useAnalytics()
    const [dialogOpen, setDialogOpen] = useState(false)

    const handleAddAccount = () => {
        trackAnalyticsEvent(ADD_BANK_ACCOUNT_EVENT)
        setDialogOpen(true)
    }

    return (
        <>
            <Row align="center">
                <Button.CTA onClick={handleAddAccount}>Add a bank account</Button.CTA>
            </Row>
            <AddAccountDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
        </>
    )
}
